import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchWorkerDuplicateAccountsCount = ({ workerID }: { workerID: number }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: `/admin/workers/${workerID}/duplicate_accounts_count` })
    handleCall(req, resolve, reject, true)
  })
